/**
 * base class for metadata model
 * 데이터 모델 병합/검증 기능 지원(병합, 검증)
 * @module  metadata-model/base
 */

// function deepCopy(dst, src) {
//     if (dst === null || src === null ||
//         typeof(src) !== 'object' || typeof(dst) !== 'object')
//         return false;

//     for (var attr in src) {
//       if (dst.hasOwnProperty(attr)) {
//         dst[attr] = deepCopy(src[attr]);
//       }
//     }

//     return true;
// }

export default class MetadataModelBase {
  constructor() {
    this._id = -1; // initialize
  }

  /**
   *
   */
  mergeModels(referenceArray, targetArray) {
    if (
      !(
        this._validateModelArray(referenceArray) &&
        this._validateModelArray(targetArray)
      )
    ) {
      window.console.log("invalid inputs provided.");
      return false;
    }

    for (let i = 0, targetLength = targetArray.length; i < targetLength; i++) {
      // test targetArray against existing targetArray
      for (let j = 0, refLength = referenceArray.length; j < refLength; j++) {
        if (referenceArray[j].merge(targetArray[i])) {
          for (
            let k = 0, frameLength = targetArray[i].frame.length;
            k < frameLength;
            k++
          ) {
            // if has already frame, exchange as new thing
            let has_frame = false;
            referenceArray[j].frame.some(frame => {
              if (
                //frame.instanceNumber === targetArray[i].frame[k].instanceNumber
                frame.sopInstanceUID === targetArray[i].frame[k].sopInstanceUID
              ) {
                // if has already frame,
                has_frame = true;
                //deepCopy(frame, targetArray[i].frame[k]);   // exchange as new thing
              }
              return has_frame;
            });

            // while if has no frame, push.
            if (has_frame === false) {
              referenceArray[j].frame.push(targetArray[i].frame[k]);
              referenceArray[j].frame.sort(function(a, b) {
                var aInstanceNum = a.instanceNumber;
                var bInstanceNum = b.instanceNumber;
                if (aInstanceNum < bInstanceNum) {
                  return -1;
                } else if (aInstanceNum > bInstanceNum) {
                  return 1;
                } else {
                  // instanceNumber가 동일할 경우, imagePositionPatient로 비교
                  if (
                    a.imagePosition !== undefined &&
                    a.imagePosition !== null &&
                    b.imagePosition !== undefined &&
                    b.imagePosition !== null
                  ) {
                    let aImagePositionPatientZ = a.imagePosition[2];
                    let bImagePositionPatientZ = b.imagePosition[2];
                    if (aImagePositionPatientZ > bImagePositionPatientZ) {
                      return -1;
                    } else {
                      return 1;
                    }
                  }
                  //  else if (
                  //   a.sliceLocation !== undefined &&
                  //   a.sliceLocation !== null &&
                  //   b.sliceLocation !== undefined &&
                  //   b.sliceLocation !== null
                  // ) {
                  //   let aSliceLocation = a.sliceLocation;
                  //   let bSliceLocation = b.sliceLocation;
                  //   if (aSliceLocation < bSliceLocation) {
                  //     return -1;
                  //   } else {
                  //     return 1;
                  //   }
                  // }
                }

                //same
                return 1;
              });
            }

            // sort
          }

          // merged successfully
          break;
        } else if (j === referenceArray.length - 1) {
          // last merge was not successful
          // this is a new targetArray
          referenceArray.push(targetArray[i]);
        }
      }
    }

    return true;
  }

  /**
   * 현재 모델과 병합이 가능한지 확인
   * @return {boolean} 병합가능하면 True, 아니면 False.
   */
  merge(model) {
    // make sure model is valid
    if (!this.validate(model)) {
      return false;
    }

    // they can be merged if they match
    if (this._id === model._id) {
      return true;
    }
    return false;
  }

  /**
   * 모델 유효성 체크
   *
   * @return {boolean} 병합가능하면 True, 아니면 False.
   */
  validate(model) {
    if (!(model && model !== null && typeof model.merge === "function")) {
      return false;
    }

    return true;
  }

  /**
   * Validate array of models.
   *
   * @param {Array.<Models>} modelArray - Array containing models.
   *
   * @return {boolean} True if array is valid. False if not.
   */
  _validateModelArray(modelArray) {
    if (!(modelArray !== null && Array === modelArray.constructor)) {
      window.console.log("invalid model array provided.");
      return false;
    }

    for (let i = 0; i < modelArray.length; i++) {
      if (
        !(
          modelArray[i] &&
          modelArray[i] !== null &&
          typeof modelArray[i].validate === "function" &&
          modelArray[i].validate(modelArray[i])
        )
      ) {
        return false;
      }
    }

    return true;
  }
}
